import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';

import {environment} from '../../../../../../environments/environment';
import {validateAllFormFields} from '../../../../../shared/components/validator/validator.service';
import {PopupNotificationService} from "./popup-notification.service";

@Component({
  selector: 'app-popup-notification',
  templateUrl: './popup-notification.component.html'
})

export class PopupNotificationComponent implements OnInit {
  baseURL = environment.baseURL;

  @Input() display: any;

  notification: any;
  hasSeen: boolean = false;
  displayDialog: any = {};
  displayUpdate?: boolean;
  header?:string;
  constructor(
    private fb: FormBuilder,
    private service: PopupNotificationService,
  ){

  }

  ngOnInit(): void {
    this.service.get().subscribe(data => {
      this.notification = data;
      if (data?.showAlert === 'Y') {
        this.header = data.titleText
        setTimeout(() => {
          this.display = Date.now();
        }, 200);
      }
      this.displayUpdate = data.topic === "UpdateAccountInfoNtf";
    });
    (window as any)['openDialogNotification'] = this.openDialogNotification;
  }

  openDialogNotification(cs: string): void {
    this.displayDialog[cs] = true;
  }

  markViewed(): void {
    if (this.notification?.showAlert === 'Y') {
      let seen = this.hasSeen ? 'Y' : 'N';
      this.service.markViewed(seen).subscribe(() => {
        this.display = 0;
      });
    } else {
      this.display = 0;
    }
  }
}
